import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Layout from "./Components/Widgets/Layout";
import { Empty } from "./Components/ui/Bits";

/** perms: any of these permissions grants access ("owner" = store owner only) */
export default function ProtectedRoute({ component, perms = [] }) {
  const { token, me, loading, can } = useAuth();
  const location = useLocation();
  if (!token) return <Navigate to="/" replace state={{ from: location.pathname + location.search }} />;
  if (loading || !me) return <div className="empty" style={{ minHeight: "100vh", alignContent: "center" }}><span className="spinner" /></div>;
  const allowed = !perms.length || (perms.includes("owner") ? me.is_owner : can(...perms));
  return (
    <Layout>
      {allowed ? component : <Empty icon="bi-lock" title="You don't have access to this page" text="Ask the store owner to add this permission to your account." />}
    </Layout>
  );
}
